<template>
  <el-dialog title="问卷分享" class="share-dialog" :visible.sync="visible" @close="dialogClose">
    <p v-if="!isCollecting" class="nocollect-tips">问卷暂停发放，分享仅提供预览，答题结果不会记录</p>
    <h2>分享预览链接</h2>
    <div class="share-addr">
      <el-input v-model="shareAddr" id="shareInput"></el-input>
      <el-button @click="handleCopyUrl">复制</el-button>
      <el-button @click="handleOpenUrl" style="float:right">打开</el-button>
    </div>
    <h2>二维码</h2>
    <div class="share-qrcode">
      <img :src="qrcodeUrl" />
      <div class="linkbox">
        <a :href="qrcodeSmall" target="_blank" download="event" class="qrcodeLink">256*256</a>
        <a :href="qrcodeMid" target="_blank" download="event" class="qrcodeLink">512*512</a>
        <a :href="qrcodeBig" target="_blank" download="event" class="qrcodeLink">1024*1024</a>
        <a :href="qrcodeSL" target="_blank" download="event" class="qrcodeLink">矢量图</a>
      </div>
      <p>用手机微信“扫一扫”二维码预览真实效果</p>
    </div>
  </el-dialog>
</template>
<script>
import { DOMAIN } from "../utils/api";
import { MSG } from "../utils/utils";

export default {
  name: "shareDialog",
  data() {
    return {
      isCollecting: false,
      qrcodeUrl: "",
      qrcodeSmall: "",
      qrcodeMid: "",
      qrcodeBig: "",
      qrcodeSL: "",
      shareAddr: "",
      qrcode: `${DOMAIN}/survey/qrcode`,
      visible: false,
    };
  },
  props: ["dialogShow", "shareSurvey"],
  watch: {
    shareSurvey: {
      deep: true,
      handler(val) {
        this.handleShare(val);
      }
    },
    dialogShow: {
      handler(val) {
        this.visible = val;
      }
    }
  },
  methods: {
    handleShare(row) {
      this.shareAddr = row.url;
      let _url = `${this.qrcode}?surveyId=${row.id}&hash=${row.hash}&type=`;
      this.qrcodeUrl = _url + 1;
      this.qrcodeSmall = _url + 1;
      this.qrcodeMid = _url + 2;
      this.qrcodeBig = _url + 3;
      this.qrcodeSL = _url + 4;
      this.isCollecting = row.status === 1;
    },
    handleOpenUrl() {
      window.open(this.shareAddr);
    },
    handleCopyUrl() {
      const range = document.createRange();
      range.selectNode(document.getElementById("shareInput"));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      MSG.success("已复制");
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    }
  }
};
</script>


<style lang="scss" scoped>
  .share-dialog {
    .nocollect-tips {
      color: #ff552e;
      margin-bottom: 20px;
    }
    h2 {
      font-size: 18px;
      margin-bottom: 15px;
    }
    .share-addr {
      margin-bottom: 20px;
      .el-input {
        width: calc(100% - 170px);
        margin-right: 10px;
      }
    }
    .share-qrcode {
      img {
        width: 150px;
        height: 150px;
        border: 1px solid #ccc;
        border-radius: 8px;
        vertical-align: middle;
      }
      p {
        display: inline-block;
        margin-top: 20px;
        margin-left: 20px;
      }
      .linkbox {
        display: inline-block;
        vertical-align: middle;
        margin-left: 30px;
      }
      .qrcodeLink {
        color: #58a6e7;
        display: block;
      }
    }
  }
 
</style>



// WEBPACK FOOTER //
// src/components/shareDialog.vue